// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"fc5c6370","845":"c32343da"}[chunkId] + ".chunk.js";
};